import { render, staticRenderFns } from "./moment.vue?vue&type=template&id=45f8b3be&"
import script from "./moment.vue?vue&type=script&lang=js&"
export * from "./moment.vue?vue&type=script&lang=js&"
import style0 from "./moment.vue?vue&type=style&index=0&id=45f8b3be&prod&lang=scss&"
import style1 from "./moment.vue?vue&type=style&index=1&id=45f8b3be&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports